import React from 'react';
import type { EigPanel } from '../../../../../lib/eigentuemer/rollen';
import { ObjektePanel } from './ObjektePanel';
import { BriefePanel } from './BriefePanel';
import { BankPanel, PortalPanel, StammdatenPanel } from './StammPanels';
import { BeteiligtePanel, DokumentePanel, KiPanel, KommunikationPanel, NotizenPanel, TerminePanel, ZustellungPanel } from './AllgemeinPanels';
import { EtvPanel, HausgeldPanel, RuecklagePanel, SondereigentumPanel, WegAbrechnungPanel, WegVerwalterPanel } from './WegPanels';
import { AbrechnungPanel, FreigabenPanel, KontoPanel, MieterPanel, SteuerPanel, VertragPanel, WegExtPanel } from './VerwaltungPanels';

/** Inhalt der Eigentümer-Panels (Handoff Eigentümer §7): je Bereich ein Panel; welche es gibt, entscheidet die Rolle. */
export function EigentuemerPanelInhalt({ panel }: { panel: EigPanel }) {
  switch (panel) {
    case 'kontakt': return <StammdatenPanel />;
    case 'portfolio':
    case 'objekte': return <ObjektePanel />;
    case 'bank': return <BankPanel />;
    case 'portal': return <PortalPanel />;
    case 'konto': return <KontoPanel />;
    case 'vertrag': return <VertragPanel />;
    case 'freigaben': return <FreigabenPanel />;
    case 'steuer': return <SteuerPanel />;
    case 'abrechnung': return <AbrechnungPanel />;
    case 'mieter': return <MieterPanel />;
    case 'wegext': return <WegExtPanel />;
    case 'hausgeld': return <HausgeldPanel />;
    case 'sondereigentum': return <SondereigentumPanel />;
    case 'wegabrechnung': return <WegAbrechnungPanel />;
    case 'ruecklage': return <RuecklagePanel />;
    case 'etv': return <EtvPanel />;
    case 'wegverwalter': return <WegVerwalterPanel />;
    case 'beteiligte': return <BeteiligtePanel />;
    case 'zustellung': return <ZustellungPanel />;
    case 'termine': return <TerminePanel />;
    case 'kommunikation': return <KommunikationPanel />;
    case 'dokumente': return <DokumentePanel />;
    case 'briefe': return <BriefePanel />;
    case 'notizen': return <NotizenPanel />;
    case 'ki': return <KiPanel />;
    default: {
      const unbekannt: never = panel;
      return unbekannt;
    }
  }
}
